import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface SeatingHeaderProps {
  seoUrl: string;
  eventTitle: string;
}

export const SeatingHeader = ({ seoUrl, eventTitle }: SeatingHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex items-center space-x-4 pt-12 md:pt-16">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => navigate(`/events/${seoUrl}`)}
        className="text-white hover:text-gray-300"
      >
        <ArrowLeft className="h-6 w-6" />
      </Button>
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">Select Your Seats</h1>
        <p className="text-gray-400">
          Select seats for {eventTitle}
        </p>
      </div>
    </div>
  );
};